
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, Select, MenuItem, Button, Typography, Paper, CircularProgress, Alert, FormControl, InputLabel } from '@mui/material';

axios.defaults.withCredentials = true;

const GenerateToken = () => {
    const [races, setRaces] = useState([]);
    const [selectedRace, setSelectedRace] = useState('');
    const [token, setToken] = useState('');
    const [error, setError] = useState('');
    
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUserAndRaces = async () => {
            try {
                const userStatus = await axios.get('/api/users/status');
                if (userStatus.data.loggedIn) {
                    const currentUser = userStatus.data.user;

                    if (currentUser.role === 'admin' || currentUser.role === 'director') {
                        const racesResponse = await axios.get(`/api/races/list?role=${currentUser.role}`);
                        setRaces(racesResponse.data);
                    } else {
                        setError('Forbidden: You do not have access to this page.');
                    }
                } else {
                    setError('You must be logged in to access this page.');
                }
            } catch (err) {
                setError('Error fetching data: ' + (err.response?.data || err.message));
            } finally {
                setLoading(false);
            }
        };

        fetchUserAndRaces();
    }, []);

    const generateToken = async () => {
        setError('');
        setToken('');

        if (!selectedRace) {
            setError('Please select a race.');
            return;
        }

        try {
            const response = await axios.post('/api/users/generate-role-token', {
                role: 'photographer',
                race_id: selectedRace,
            });
            setToken(response.data.token);
        } catch (err) {
            setError(err.response?.data || 'Error generating token.');
        }
    };

    if (loading) {
        return <CircularProgress />;
    }

    if (error) {
        return (
            <Container maxWidth="sm" sx={{ mt: 4 }}>
                <Alert severity="error">{error}</Alert>
            </Container>
        );
    }

    return (
        <Container maxWidth="md" sx={{ mt: 4 }}>
            <Paper elevation={3} sx={{ p: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    Generate Photographer Token
                </Typography>
                <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Select Race</InputLabel>
                    <Select
                        value={selectedRace}
                        label="Select Race"
                        onChange={(e) => setSelectedRace(e.target.value)}
                    >
                        <MenuItem value="">
                            <em>-- Select a race --</em>
                        </MenuItem>
                        {races.map(race => (
                            <MenuItem key={race.id} value={race.id}>{race.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <Button variant="contained" color="primary" onClick={generateToken} fullWidth>
                    Generate Token
                </Button>
                {token && (
                    <Alert severity="success" sx={{ mt: 2 }}>
                        <Typography>Generated Token:</Typography>
                        <pre>{token}</pre>
                    </Alert>
                )}
            </Paper>
        </Container>
    );
};

export default GenerateToken;
